import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component DollarSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <DollarSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <DollarSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DollarSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="DollarSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M8 10H7v1H5v-1H4a1 1 0 01-1-1V8h1v.7a.3.3 0 00.3.3h3.4a.3.3 0 00.3-.3V6.3a.3.3 0 00-.3-.3H4a1 1 0 01-1-1V3a1 1 0 011-1h1V1h2v1h1a1 1 0 011 1v1H8v-.7a.3.3 0 00-.3-.3H4.3a.3.3 0 00-.3.3v1.4a.3.3 0 00.3.3H8a1 1 0 011 1v3a1 1 0 01-1 1z"
        fillRule="evenodd"
      />
    </svg>
  )
);
DollarSmallIcon.displayName = "DollarSmallIcon";
export default DollarSmallIcon;
